import { Component } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Profile } from '../../services/auth/auth.model';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SettingService } from 'src/common/services/setting/setting.service';
import { debounceTime } from 'rxjs/operators';
import { BackurlService } from 'src/common/services/backurl/backurl.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent {

  public usersActivePending: Profile[] = [];
  public usersDiplayed: Profile[] = [];

  public sortLocalForm: FormGroup = this.fb.group({
    agency: [null],
    active: [true],
  });


  constructor(
    public auth: AuthService,
    protected router: Router,
    protected fb: FormBuilder,
    public setting: SettingService,
    public backURL: BackurlService,
  ) {
    const defaultAgency = this.auth.isRole('admin') ? '' : this.auth.profile?.values?.agency || null;
    this.sortLocalForm.patchValue({ agency: defaultAgency }, { emitEvent: false });
  }

  ngOnInit(): void {

    this.auth.usersActivePending$.subscribe(profiles => {
      this.usersActivePending = profiles;
      this._listRefresh();
    });

    this.sortLocalForm.valueChanges.pipe(debounceTime(500)).subscribe(() => {
      setTimeout(() => {
        this._listRefresh();
      }, 10);
    });
  }

  _listRefresh() {
    const { agency, active } = this.sortLocalForm.value;

    this.usersDiplayed = this.usersActivePending.filter(user => {
      const matchesAgency = agency !== null && agency !== '' ? user.values.agency === agency : true;
      const matchesActive = active ? user.values.status === 'active' : true;
      return matchesAgency && matchesActive;
    });
  }


  addUser() {
    if (!this.auth.isRole('admin')) {
      return;
    }
    this.backURL.addURL('/settings/users');
    this.router.navigate([`/settings/users/0`]);
  }

  editUser(user: Profile) {
    this.backURL.addURL('/settings/users');
    this.router.navigate([`/profile/edit/${user.values.$key || user.values.ref}`]);
  }

  removeInvitation(invitation, e) {
    e.stopPropagation();
    this.auth.removeInvitation(invitation);
  }

  getGmailSyncDate(user: Profile): Date | null {
    const raw = user?.values?.gmailSignatureSyncedAt as any;

    if (!raw) {
      return null;
    }

    if (raw instanceof Date) {
      return raw;
    }

    if (typeof raw?.toDate === 'function') {
      return raw.toDate();
    }

    const parsed = new Date(raw);
    return isNaN(parsed.getTime()) ? null : parsed;
  }
}
